var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "overlay-color": "#000",
        "overlay-opacity": "0.66",
        persistent: _vm.dialog.persistent,
        "max-width": _vm.dialog.width
      },
      model: {
        value: _vm.dialog.value,
        callback: function($$v) {
          _vm.$set(_vm.dialog, "value", $$v)
        },
        expression: "dialog.value"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "dialog-card" },
        [
          _c(
            "v-card-title",
            {
              staticClass: "d-flex justify-space-between",
              class: _vm.dialog.closeIcon.value ? "dialog-title-close" : null
            },
            [
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.dialog.header) }
              }),
              _vm.dialog.closeIcon.value
                ? [
                    _vm.dialog.closeIcon.func == null
                      ? [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function($event) {
                                  return _vm.close()
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          )
                        ]
                      : [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: { click: _vm.dialog.closeIcon.func }
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          )
                        ]
                  ]
                : _vm._e()
            ],
            2
          ),
          _c("v-card-text", { class: _vm.dialog.textClass }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.dialog.text) } })
          ]),
          _vm.isAction
            ? _c(
                "v-card-actions",
                [
                  !_vm.isMobile ? _c("v-spacer") : _vm._e(),
                  _vm.dialog.closeBtn.value
                    ? _c(
                        "v-btn",
                        {
                          class: [
                            _vm.dialog.closeBtn.primaryStyle
                              ? "btn-primary"
                              : "btn-secondary"
                          ],
                          attrs: {
                            density: "default",
                            variant: "elevated",
                            disabled: _vm.dialog.closeBtn.disabled
                          },
                          on: {
                            click: function($event) {
                              return _vm.close()
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.dialog.closeBtn.text) + " ")]
                      )
                    : _vm._e(),
                  _vm.dialog.secondaryBtn.text
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "btn-secondary",
                          attrs: {
                            density: "default",
                            variant: "elevated",
                            disabled: _vm.dialog.secondaryBtn.disabled,
                            loading: _vm.dialog.secondaryBtn.loading
                          },
                          on: { click: _vm.dialog.secondaryBtn.func }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.dialog.secondaryBtn.text) + " "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.dialog.primaryBtn.text
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "btn-primary",
                          attrs: {
                            variant: "elevated",
                            density: "default",
                            disabled: _vm.dialog.primaryBtn.disabled,
                            loading: _vm.dialog.primaryBtn.loading
                          },
                          on: { click: _vm.dialog.primaryBtn.func }
                        },
                        [_vm._v(" " + _vm._s(_vm.dialog.primaryBtn.text) + " ")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }